module.exports = __webpack_public_path__ + "img/logohaitunjinfu.4045ef5c.png";